const objContext = JSON.parse(sessionStorage.getItem("context"));

if (objContext == null || objContext.store_name == null)
  location.href = 'index.html';
var id_current_store = null, url_picture = null, objStoreInfo = null;

const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab');
let optionsNav = document.querySelectorAll('.nav-options__item'),
  reportPanels = document.querySelectorAll('.report-panel');

//Botones para exportar
let btnExportMoreSellsProduct = document.querySelector('#btnExportMoreSellsProduct'),
  btnExportTotalSales = document.querySelector('#btnExportTotalSales'),
  btnExportAverageSale = document.querySelector('#btnExportAverageSale'),
  btnExportCanceledOrders = document.querySelector('#btnExportCanceledOrders');
let csvMoreSellProduct = ``,
  csvTotalSales = ``,
  csvAverageSale = ``,
  csvCanceledOrders = ``;

if (sectionTab != null)
  sectionTab[2].classList.add('sidebar-menu-container-section-tab--active');


document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

window.addEventListener("load", loadPage);
function loadPage() {
  id_current_store = localStorage.getItem("currentStore");

  if (id_current_store == null || objContext == null)
    location.href = 'index.html';
  else {
    document.querySelector('.sidebar-profile-img img').src = objContext.store_image
    document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')
    UI.hideLoader();
  }
}




function loadCharts(data) {
  let container = document.querySelector("#graphicPedidos");

  let arrayToDraw = [
    ['Producto', 'Total', { role: 'style' }],
  ];

  arrayToDraw = arrayToDraw.concat(data);


  google.charts.load('current', { 'packages': ['corechart'] });
  google.charts.setOnLoadCallback(drawChart);

  function drawChart() {
    var data = google.visualization.arrayToDataTable(arrayToDraw);

    var options = {
      title: 'Los más vendidos',
      titleFontSize: 18,
      fontSize: 12,
    };

    var chart = new google.visualization.PieChart(container);
    chart.draw(data, options);
  }



}

function loadChartTotalSales(data) {
  let container = document.querySelector("#graphicTotalSells");

  let arrayToDraw = [
    ['Día', 'Venta', { role: 'style' }],
  ];

  arrayToDraw = arrayToDraw.concat(data);


  google.charts.load('current', { 'packages': ['corechart'] });
  google.charts.setOnLoadCallback(drawChart);

  function drawChart() {
    var data = google.visualization.arrayToDataTable(arrayToDraw);

    var options = {
      title: 'Total de ventas',
      titleFontSize: 16,
      vAxis: { minValue: 0 },
      isStacked: false,
      axisTitlesPosition: 'none',
      legend: { position: "none" },
      annotations: {
        alwaysOutside: false
      }
    };

    var chart = new google.visualization.BarChart(container);
    chart.draw(data, options);
  }

}

function loadChartCanceledOrders(data) {
  let container = document.querySelector("#graphicCanceledOrders");

  let arrayToDraw = [
    ['Día', 'Cancelaciones', { role: 'style' }],
  ];

  arrayToDraw = arrayToDraw.concat(data);


  google.charts.load('current', { 'packages': ['corechart'] });
  google.charts.setOnLoadCallback(drawChart);

  function drawChart() {
    var data = google.visualization.arrayToDataTable(arrayToDraw);

    var options = {
      title: 'Ordenes canceladas',
      titleFontSize: 16,
      vAxis: { minValue: 0 },
      isStacked: false,
      axisTitlesPosition: 'none',
      legend: { position: "none" },
      annotations: {
        alwaysOutside: false
      }
    };

    var chart = new google.visualization.BarChart(container);
    chart.draw(data, options);
  }

}

function loadChartAverageSale(data) {
  let container = document.querySelector("#graphicAverageSale");

  let arrayToDraw = [
    ['Día', 'Ticket promedio', { role: 'style' }],
  ];

  arrayToDraw = arrayToDraw.concat(data);


  google.charts.load('current', { 'packages': ['corechart'] });
  google.charts.setOnLoadCallback(drawChart);

  function drawChart() {
    var data = google.visualization.arrayToDataTable(arrayToDraw);


    var options = {
      title: 'Ticket promedio',
      titleFontSize: 16,
      vAxis: { minValue: 0 },
      isStacked: false,
      axisTitlesPosition: 'none',
      legend: { position: "none" },
      annotations: {
        alwaysOutside: false
      }
    };

    var chart = new google.visualization.BarChart(container);
    chart.draw(data, options);
  }


}


function showOptionReport(numberOptionPanel) {
  document.querySelector('.nav-options__item-active').classList.remove('nav-options__item-active');
  document.querySelector(`[data-option = "${numberOptionPanel}"]`).classList.add('nav-options__item-active');

  reportPanels.forEach((panel) => { panel.classList.add('hide'); });
  reportPanels[numberOptionPanel].classList.remove('hide');

  if (reportPanels[numberOptionPanel].querySelector('.select-days-range span').innerText == 'Selecciona una opción') {
    let start_date = moment().subtract(6, 'days'), end_date = moment();

    if (numberOptionPanel == 1) {
      $('#daysAverageSale').data('daterangepicker').setStartDate(start_date);
      $('#daysAverageSale').data('daterangepicker').setEndDate(end_date);
      initSelectAverageSale.cb(start_date, end_date);
    }
    else if (numberOptionPanel == 2) {
      $('#daysMoreSellProduct').data('daterangepicker').setStartDate(start_date);
      $('#daysMoreSellProduct').data('daterangepicker').setEndDate(end_date);
      initSelectMoreSellProduct.cb(start_date, end_date);

      /*$('#daysMoreSellProduct').data('daterangepicker').setStartDate(start_date);
      $('#daysMoreSellProduct').data('daterangepicker').setEndDate(end_date);
      initSelectSellsVolume.cb(start_date, end_date);*/
    }
    else if (numberOptionPanel == 3) {
      $('#daysCancelled').data('daterangepicker').setStartDate(start_date);
      $('#daysCancelled').data('daterangepicker').setEndDate(end_date);
      initSelectCancelled.cb(start_date, end_date);
    }
  }
}

/// inits selects rank
var initSelectTotalSales = {
  cb: function (start, end) {
    $('#daysTotalSells span').html(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));

    let dateString = $('#daysTotalSells span').text();

    let objectSend = {
      store_id: localStorage.getItem('currentStore'),
      start_date: dateString.substring(0, 10) + " 00:00:00",
      end_date: dateString.substring(13, 23) + " 23:59:59"
    }

    totalSales(objectSend);
  },
  initSelect: function () {
    $('#daysTotalSells').daterangepicker({
      alwaysShowCalendars: false,
      ranges: {
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 15 días': [moment().subtract(14, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()]
      },
      "locale": {
        "format": "YYYY/MM/DD",
        "separator": " - ",
        "applyLabel": "Seleccionar",
        "cancelLabel": "Cancelar",
        "fromLabel": "desde",
        "toLabel": "hasta",
        "customRangeLabel": "Personalizado",
        "weekLabel": "S",
        "daysOfWeek": [
          "Do",
          "Lu",
          "Ma",
          "Mi",
          "Ju",
          "Vi",
          "Sa"
        ],
        "monthNames": [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        "firstDay": 1
      },
    }, this.cb);

    setTimeout(() => {
      let start_date = moment().subtract(6, 'days'), end_date = moment();
      $('#daysTotalSells').data('daterangepicker').setStartDate(start_date);
      $('#daysTotalSells').data('daterangepicker').setEndDate(end_date);
      this.cb(start_date, end_date);
    }, 250);
  }
}

var initSelectAverageSale = {
  cb: function (start, end) {
    $('#daysAverageSale span').html(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));

    let dateString = $('#daysAverageSale span').text();

    let objectSend = {
      store_id: localStorage.getItem('currentStore'),
      start_date: dateString.substring(0, 10) + " 00:00:00",
      end_date: dateString.substring(13, 23) + " 23:59:59"
    }

    averageSale(objectSend);
  },
  initSelect: function () {
    $('#daysAverageSale').daterangepicker({
      alwaysShowCalendars: false,
      ranges: {
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 15 días': [moment().subtract(14, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()]
      },
      "locale": {
        "format": "YYYY/MM/DD",
        "separator": " - ",
        "applyLabel": "Seleccionar",
        "cancelLabel": "Cancelar",
        "fromLabel": "desde",
        "toLabel": "hasta",
        "customRangeLabel": "Personalizado",
        "weekLabel": "S",
        "daysOfWeek": [
          "Do",
          "Lu",
          "Ma",
          "Mi",
          "Ju",
          "Vi",
          "Sa"
        ],
        "monthNames": [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        "firstDay": 1
      },
    }, this.cb);
  }
}

var initSelectMoreSellProduct = {
  cb: function (start, end) {
    $('#daysMoreSellProduct span').html(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));

    let dateString = $('#daysMoreSellProduct span').text();

    let objectSend = {
      store_id: localStorage.getItem('currentStore'),
      start_date: dateString.substring(0, 10) + " 00:00:00",
      end_date: dateString.substring(13, 23) + " 23:59:59"
    }

    moreSellProduct(objectSend);
  },
  initSelect: function () {
    $('#daysMoreSellProduct').daterangepicker({
      alwaysShowCalendars: false,
      ranges: {
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 15 días': [moment().subtract(14, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()]
      },
      "locale": {
        "format": "YYYY/MM/DD",
        "separator": " - ",
        "applyLabel": "Seleccionar",
        "cancelLabel": "Cancelar",
        "fromLabel": "desde",
        "toLabel": "hasta",
        "customRangeLabel": "Personalizado",
        "weekLabel": "S",
        "daysOfWeek": [
          "Do",
          "Lu",
          "Ma",
          "Mi",
          "Ju",
          "Vi",
          "Sa"
        ],
        "monthNames": [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        "firstDay": 1
      },
    }, this.cb);
  }
}

/*
var initSelectSellsVolume = {
  cb: function (start, end) {
    $('#daysMoreSellProduct span').html(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));

    let dateString = $('#daysMoreSellProduct span').text();

    let objectSend = {
      store_id: localStorage.getItem('currentStore'),
      start_date: dateString.substring(0, 10) + " 00:00:00",
      end_date: dateString.substring(13, 23) + " 23:59:59"
    }

    volumeSells(objectSend);
  },
  initSelect: function () {
    $('#daysMoreSellProduct').daterangepicker({
      alwaysShowCalendars: false,
      "opens": "left",
      ranges: {
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 15 días': [moment().subtract(14, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()]
      },
      "locale": {
        "format": "YYYY/MM/DD",
        "separator": " - ",
        "applyLabel": "Seleccionar",
        "cancelLabel": "Cancelar",
        "fromLabel": "desde",
        "toLabel": "hasta",
        "customRangeLabel": "Personalizado",
        "weekLabel": "S",
        "daysOfWeek": [
          "Do",
          "Lu",
          "Ma",
          "Mi",
          "Ju",
          "Vi",
          "Sa"
        ],
        "monthNames": [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        "firstDay": 1
      },
    }, this.cb);
  }
}
*/


var initSelectCancelled = {
  cb: function (start, end) {
    $('#daysCancelled span').html(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));

    let dateString = $('#daysCancelled span').text();

    let objectSend = {
      store_id: localStorage.getItem('currentStore'),
      start_date: dateString.substring(0, 10) + " 00:00:00",
      end_date: dateString.substring(13, 23) + " 23:59:59"
    }

    let objectSendStatus = {
      store_id: localStorage.getItem('currentStore'),
      start_date: dateString.substring(0, 10) + " 00:00:00",
      end_date: dateString.substring(13, 23) + " 23:59:59",
      tran_status: 3
    }

    cancelledOrders(objectSend, objectSendStatus);
  },
  initSelect: function () {
    $('#daysCancelled').daterangepicker({
      alwaysShowCalendars: false,
      ranges: {
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 15 días': [moment().subtract(14, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()]
      },
      "locale": {
        "format": "YYYY/MM/DD",
        "separator": " - ",
        "applyLabel": "Seleccionar",
        "cancelLabel": "Cancelar",
        "fromLabel": "desde",
        "toLabel": "hasta",
        "customRangeLabel": "Personalizado",
        "weekLabel": "S",
        "daysOfWeek": [
          "Do",
          "Lu",
          "Ma",
          "Mi",
          "Ju",
          "Vi",
          "Sa"
        ],
        "monthNames": [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        "firstDay": 1
      },
    }, this.cb);
  }
}


// services
//ventas totales
function totalSales(data) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/total_sales',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {
        response.json().then(function (json) {
          UI.hideLoader();
          document.querySelector('.total-sells-number span').textContent = "$" + parseFloat(json.total_sales / 100).toFixed(2);
          totalSalesBuildTable(data);
        });

      } else {
        response.json().then(function () {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar los datos.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}

function totalSalesBuildTable(data) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/sells_by_day',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {

        response.json().then(function (json) {
          if (json.length == 0) {
            document.querySelector('#tableTotalSells').innerHTML = '';
            document.querySelector('#tableTotalSells').innerHTML = '<p>No hay ventas para mostrar.</p>';
            btnExportTotalSales.classList.add('hide');
            document.querySelector('#graphicTotalSellsContainer').classList.add('hide');
            UI.hideLoader();
          }

          else {
            csvTotalSales = ``;

            document.querySelector('#tableTotalSells').innerHTML = '';
            let tableRowsLayout = ``;
            csvTotalSales = `data:text/csv;charset=utf-8,Fecha,Venta diaria\r\n`;

            json.forEach((element) => {
              tableRowsLayout = tableRowsLayout + `
                  <tr>
                    <td>${element.day.substring(0, 10)}</td>
                    <td>$${parseFloat(element.total_value / 100).toFixed(2)}</td>
                  </tr>
                `;

              csvTotalSales += `${element.day.substring(0, 10)},${parseFloat(element.total_value / 100).toFixed(2)}\r\n`;
            });

            let tableLayout = `
              <table class="mt-1">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Venta diaria</th>
                  </tr>
                </thead>

                <tbody>
                    ${tableRowsLayout}
                </tbody>
              </table>
            `;

            document.querySelector('#tableTotalSells').insertAdjacentHTML('beforeend', tableLayout);
            btnExportTotalSales.classList.remove('hide');

            // preparar objeto para gráfica
            let arrayToGraphic = [];

            for (let a = 0; a < json.length; a++) {
              if (a % 2 == 0) {
                arrayToGraphic.push([
                  json[a].day.substring(0, 10),
                  json[a].total_value / 100,
                  '#f7b541'
                ]);
              }
              else {
                arrayToGraphic.push([
                  json[a].day.substring(0, 10),
                  json[a].total_value / 100,
                  '#6acf7f'
                ]);
              }
            }

            loadChartTotalSales(arrayToGraphic);
            document.querySelector('#graphicTotalSellsContainer').classList.remove('hide');
            UI.hideLoader();

          }
        });

      } else {
        response.json().then(function () {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar las ventas.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}


// ticket promedio
function averageSale(data) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/average_sale',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {

        response.json().then(function (json) {
          UI.hideLoader();
          document.querySelector('.average-sale-number span').textContent = "$" + parseFloat(json.average_sale / 100).toFixed(2);
          averageSaleBuildTable(data);
        });

      } else {
        response.json().then(function (content) {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar los datos.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}

function averageSaleBuildTable(data) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/sells_by_day',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {

        response.json().then(function (json) {
          if (json.length == 0) {
            document.querySelector('#tableAverageSale').innerHTML = '';
            document.querySelector('#tableAverageSale').innerHTML = '<p>No hay ticket promedio para mostrar.</p>';
            btnExportAverageSale.classList.add('hide');
            document.querySelector('#graphicAverageSaleContainer').classList.add('hide');
            UI.hideLoader();
          }

          else {
            csvAverageSale = ``;

            document.querySelector('#tableAverageSale').innerHTML = '';
            let tableRowsLayout = ``;
            csvAverageSale = `data:text/csv;charset=utf-8,Fecha,Ticket promedio\r\n`;

            json.forEach((element) => {
              let average = element.total_value / element.total_sales;
              tableRowsLayout = tableRowsLayout + `
                  <tr>
                    <td>${element.day.substring(0, 10)}</td>
                    <td>$${parseFloat(average / 100).toFixed(2)}</td>
                  </tr>
                `;

              csvAverageSale += `${element.day.substring(0, 10)},${parseFloat(average / 100).toFixed(2)}\r\n`;
            });

            let tableLayout = `
              <table class="mt-1">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Ticket promedio</th>
                  </tr>
                </thead>

                <tbody>
                    ${tableRowsLayout}
                </tbody>
              </table>
            `;

            document.querySelector('#tableAverageSale').insertAdjacentHTML('beforeend', tableLayout);
            btnExportAverageSale.classList.remove('hide');

            // preparar objeto para gráfica
            let arrayToGraphic = [];

            for (let a = 0; a < json.length; a++) {
              let average = json[a].total_value / json[a].total_sales;
              if (a % 2 == 0) {
                arrayToGraphic.push([
                  json[a].day.substring(0, 10),
                  average / 100,
                  '#f7b541'
                ]);
              }

              else {
                arrayToGraphic.push([
                  json[a].day.substring(0, 10),
                  average / 100,
                  '#6acf7f'
                ]);
              }
            }

            loadChartAverageSale(arrayToGraphic);
            document.querySelector('#graphicAverageSaleContainer').classList.remove('hide');
            UI.hideLoader();

          }
        });

      } else {
        response.json().then(function () {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar las ventas.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}



//Producto más vendido
function moreSellProduct(data) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/more_sells_products',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {

        response.json().then(function (json) {

          if (json.length == 0) {
            document.querySelector('#tableMoreSellProduct').innerHTML = '';
            document.querySelector('#tableMoreSellProduct').innerHTML = '<p>No hay productos para mostrar.</p>';
            btnExportCanceledOrders.classList.add('hide');
            UI.hideLoader();
          }

          else {
            csvMoreSellProduct = ``;

            document.querySelector('#tableMoreSellProduct').innerHTML = '';
            let tableRowsLayout = ``;
            csvMoreSellProduct = `data:text/csv;charset=utf-8,Cantidad,Producto,Total por producto\r\n`;
            document.querySelector('.more-sell-number span').textContent = `${json[0].name}`;

            json.forEach((element) => {
              tableRowsLayout = tableRowsLayout + `
                  <tr>
                    <td class="td-10 txt-right td-10-fix">${element.total_sales}</td>
                    <td class="td-bold">${element.name}</td>
                    <td>$${parseFloat(element.total_value / 100).toFixed(2)}</td>
                  </tr>
                `;

              csvMoreSellProduct += `${element.total_sales},${escape(element.name)},${parseFloat(element.total_value / 100).toFixed(2)}\r\n`;
            });

            let tableLayout = `
              <table class="mt-1">
                <thead>
                  <tr>
                    <th>Cantidad</th>
                    <th>Producto</th>
                    <th>Total por producto</th>
                  </tr>
                </thead>

                <tbody>
                    ${tableRowsLayout}
                </tbody>
              </table>
            `;

            document.querySelector('#tableMoreSellProduct').insertAdjacentHTML('beforeend', tableLayout);
            btnExportMoreSellsProduct.classList.remove('hide');

            // preparar objeto para gráfica
            let arrayToGraphic = [];

            for (let a = 0; a < json.length; a++) {

              if (a == 5) { // Into HU indicates only 5 products for pastel graphic
                break;
              }

              else {
                if (a % 2 == 0) {
                  arrayToGraphic.push([
                    json[a].name,
                    json[a].total_value / 100,
                    '#f7b541'
                  ]);
                }

                else {
                  arrayToGraphic.push([
                    json[a].name,
                    json[a].total_value / 100,
                    '#6acf7f'
                  ]);
                }
              }
            }

            loadCharts(arrayToGraphic)
            document.querySelector('#graphicMoreSaleContainer').classList.remove('hide');

            UI.hideLoader();

          }
        });

      } else {
        response.json().then(function () {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar transacciones.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}

//Volumen de venta por horas
function volumeSells(data) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/sells_by_day',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {

        response.json().then(function (json) {
          UI.hideLoader();
        });

      } else {
        response.json().then(function (content) {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar los datos.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}

//ordenes canceladas
function cancelledOrders(data, dataTable) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/cancelled_orders',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {

        response.json().then(function (json) {
          UI.hideLoader();
          document.querySelector('.order-canceled-number span').textContent = json.cancelled_orders;
          cancelledOrdersBuildTable(dataTable);
        });

      } else {
        response.json().then(function (content) {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar los datos.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}

function cancelledOrdersBuildTable(data) {
  UI.showLoader();
  fetch(
    BASE_URLS.Dinny.api + '/reports/sells_by_day',
    {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) {

        response.json().then(function (json) {
          if (json.length == 0) {
            document.querySelector('#tableCanceledOrders').innerHTML = '';
            document.querySelector('#tableCanceledOrders').innerHTML = '<p>No hay ordenes canceladas para mostrar.</p>';
            btnExportCanceledOrders.classList.add('hide');
            document.querySelector('#graphicCanceledOrdersContainer').classList.add('hide');
            UI.hideLoader();
          }

          else {
            csvCanceledOrders = ``;

            document.querySelector('#tableCanceledOrders').innerHTML = '';
            let tableRowsLayout = ``;
            csvCanceledOrders = `data:text/csv;charset=utf-8,Fecha,Cancelaciones\r\n`;

            json.forEach((element) => {
              tableRowsLayout = tableRowsLayout + `
                  <tr>
                    <td>${element.day.substring(0, 10)}</td>
                    <td>${element.total_sales}</td>
                  </tr>
                `;

              csvCanceledOrders += `${element.day.substring(0, 10)},${element.total_sales}\r\n`;
            });

            let tableLayout = `
              <table class="mt-1">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Cancelaciones</th>
                  </tr>
                </thead>

                <tbody>
                    ${tableRowsLayout}
                </tbody>
              </table>
            `;

            document.querySelector('#tableCanceledOrders').insertAdjacentHTML('beforeend', tableLayout);
            btnExportCanceledOrders.classList.remove('hide');

            // preparar objeto para gráfica
            let arrayToGraphic = [];

            for (let a = 0; a < json.length; a++) {
              if (a % 2 == 0) {
                arrayToGraphic.push([
                  json[a].day.substring(0, 10),
                  json[a].total_sales,
                  '#f7b541'
                ]);
              }

              else {
                arrayToGraphic.push([
                  json[a].day.substring(0, 10),
                  json[a].total_sales,
                  '#6acf7f'
                ]);
              }
            }

            loadChartCanceledOrders(arrayToGraphic);
            document.querySelector('#graphicCanceledOrdersContainer').classList.remove('hide');
            UI.hideLoader();

          }
        });

      } else {
        response.json().then(function () {
          if (403 == response.status) {
            window.location.href = 'login.html'
          } else {
            UI.hideLoader();
            UI.alert("Ocurrió un error al consultar las ventas.", 'error')
          }
        });
      }
    }).catch(function (e) {
      UI.hideLoader();
      UI.alert('Ocurrió un error.', 'error');
      console.log(e);
    });

}


function initRankSelects() {
  initSelectTotalSales.initSelect();
  initSelectAverageSale.initSelect();
  initSelectMoreSellProduct.initSelect();
  initSelectCancelled.initSelect();
}


function export_csv(e) {
  let encodedUri = (csvMoreSellProduct)
  let link = document.createElement("a")
  link.setAttribute("href", encodedUri)
  link.setAttribute("download", `Más vendidos - ${objContext.store_name.replace(/\\/, '')}.csv`)
  link.style = 'display: none'
  document.body.appendChild(link)

  link.click()
  return false
}

function export_csv_total_sales(e) {
  let encodedUri = (csvTotalSales)
  let link = document.createElement("a")
  link.setAttribute("href", encodedUri)
  link.setAttribute("download", `Ventas diarias - ${objContext.store_name.replace(/\\/, '')}.csv`)
  link.style = 'display: none'
  document.body.appendChild(link)

  link.click()
  return false
}

function export_csv_average_sale(e) {
  let encodedUri = (csvAverageSale)
  let link = document.createElement("a")
  link.setAttribute("href", encodedUri)
  link.setAttribute("download", `Ticket promedio - ${objContext.store_name.replace(/\\/, '')}.csv`)
  link.style = 'display: none'
  document.body.appendChild(link)

  link.click()
  return false
}

function export_csv_canceled_orders(e) {
  let encodedUri = (csvCanceledOrders)
  let link = document.createElement("a")
  link.setAttribute("href", encodedUri)
  link.setAttribute("download", `Ordenes canceladas - ${objContext.store_name.replace(/\\/, '')}.csv`)
  link.style = 'display: none'
  document.body.appendChild(link)

  link.click()
  return false
}





// Event listeners
optionsNav.forEach((option) => {
  option.addEventListener("click", (event) => {
    showOptionReport(event.target.dataset.option);
  });
});

btnExportMoreSellsProduct.addEventListener('click', () => {
  export_csv();
});

btnExportTotalSales.addEventListener('click', () => {
  export_csv_total_sales();
});

btnExportAverageSale.addEventListener('click', () => {
  export_csv_average_sale();
});

btnExportCanceledOrders.addEventListener('click', () => {
  export_csv_canceled_orders();
});


//loadCharts();
initRankSelects();